import * as style from './style.module.css';

const SkeletonBlock = ({ width = '100%', height = '1rem', borderRadius = 'var(--radius-s)', className = '' }) => (
    <div className={`${style.skeleton} ${className}`} style={{ width, height, borderRadius }} data-testid="skeleton-block" />
);

export default SkeletonBlock;
